interface ConvertedObject {
  [key: string]: any;
}

export const convertKeysToSnakeCase = (
  obj: ConvertedObject
): ConvertedObject => {
  const convertedObj: ConvertedObject = {};

  Object.keys(obj).forEach((key) => {
    const convertedKey = key.replace(
      /[A-Z]/g,
      (letter) => `_${letter.toLowerCase()}`
    );
    convertedObj[convertedKey] = obj[key];
  });

  return convertedObj;
};
